import { TreeNodeType } from './schemaExplorer';
import { SchemaRelationTypeGroup } from './schemaRelations';
import { SchemaExplorerFile } from './schemaExplorerFile';

export enum SchemaResourceType {
  TABLE = 'TABLE',
  VIEW = 'VIEW'
}

export interface SchemaExplorerFolder {
  collapsed: boolean;
  resourceType: SchemaResourceType;
  name: string;
  files: SchemaExplorerFile[];
  relationGroups: SchemaRelationTypeGroup[];
  treeNodeType: TreeNodeType;
  id: number;
}
